// Event names published by the backend over Ably (`channel.publish(event, …)`),
// read off `message.name`, and persisted on notifications as `event`. Values must
// match the backend event strings exactly. Shared by the realtime service, the
// notifications store, and the notification center.
export enum RealtimeEvent {
  Card3dsValidationRequested = 'card_3ds_validation_requested',
  DashboardInvalidated = 'dashboard_invalidated',
  PaymentAccountCredited = 'payment_account_credited',
  CardRequestSubmitted = 'card_request_submitted',
  CardRequestApproved = 'card_request_approved',
  CardRequestRejected = 'card_request_rejected',
  CardRequestCancelled = 'card_request_cancelled',
}
